import { createContext, useContext, useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "bbe-favourites";
const FavContext = createContext();

function loadFavs() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch { return []; }
}

export function FavouritesProvider({ children }) {
  const [favIds, setFavIds] = useState(loadFavs);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favIds));
  }, [favIds]);

  const toggleFav = useCallback((id) => {
    setFavIds((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  }, []);

  const isFav = useCallback((id) => favIds.includes(id), [favIds]);

  return (
    <FavContext.Provider value={{ favIds, toggleFav, isFav, count: favIds.length }}>
      {children}
    </FavContext.Provider>
  );
}

export function useFavourites() {
  return useContext(FavContext);
}
